var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcellence = function SvgExcellence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#excellence_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.117 8.252 12.297.789a1.46 1.46 0 0 0-2.052-.576 1.46 1.46 0 0 0-.535.576L6.885 8.252H1.397a1.34 1.34 0 0 0-1.3.842 1.35 1.35 0 0 0 .356 1.51l4.764 3.327-2.64 6.074a1.444 1.444 0 0 0 1.187 1.988c.299.03.6-.036.86-.186l2.119-1.194a3.468 3.468 0 0 1 2.814-5.61h4.572l2.554-6.751z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.414 8.86 3.077 8.142h5.987a1.46 1.46 0 0 1 1.415.92 1.47 1.47 0 0 1-.382 1.645l-5.197 3.63 2.88 6.627a1.575 1.575 0 0 1-1.294 2.168 1.57 1.57 0 0 1-.94-.203l-6.956-3.92-6.96 3.92a1.565 1.565 0 0 1-2.313-1.006 1.58 1.58 0 0 1 .08-.959l2.88-6.627-5.197-3.63a1.468 1.468 0 0 1 1.03-2.565h5.987l3.08-8.142a1.59 1.59 0 0 1 2.237-.628c.25.152.451.37.585.628Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "excellence_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgExcellence;